import $ from 'jquery';

$(document).on('show.bs.collapse', '[id^="editions-collapse-"]', function() {
    const collapseId = $(this).attr('id');
    const button = $(`[data-target="#${collapseId}"]`);
    const btnText = button.find('.btn-text');
    const hideText = button.data('text-hide');

    if (hideText && btnText.length) {
        btnText.text(hideText);
    }
});

$(document).on('hide.bs.collapse', '[id^="editions-collapse-"]', function() {
    const collapseId = $(this).attr('id');
    const button = $(`[data-target="#${collapseId}"]`);
    const btnText = button.find('.btn-text');
    const showText = button.data('text-show');

    if (showText && btnText.length) {
        btnText.text(showText);
    }
});
